import React, { Component } from 'react';
import { Button, Card, Image, Grid, Header, Icon } from 'semantic-ui-react'

class ArtistDashboardUi extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {

        const ArtistDashboardSections = (props) => (
            <Header as='h2'>
              <Icon name={props.icon} />
              <Header.Content>
                {props.value}
                <Header.Subheader>{props.text}</Header.Subheader>
              </Header.Content>
            </Header>
          )

        return (
            <div>

                <Grid
                    textAlign='center'
                    // style={{ height: '100%' }}
                    verticalAlign='middle' >
                    <Grid.Column style={{ maxWidth: 550 }}>

                        <Image src='https://s3.eu-central-1.amazonaws.com/printbaimages/printboda_logo.png' fluid />

                        <Header as='h2' icon>
                            <Icon name='settings' />
                            Welcome {this.props.artistInfoObject.urlname}
                            <Header.Subheader>View Your Account Details and balance.</Header.Subheader>
                        </Header>


                        {/* TOTAL ORDERS */}
                        <ArtistDashboardSections 
                            text={"Total number of orders received"} 
                            icon={"upload"} 
                            value={this.props.dashboardInfo.orders.length+" orders(s)"} />

                        {/* DELIVERED ORDERS */}
                        <ArtistDashboardSections 
                            text={"Total number of orders delivered"} 
                            icon={"motorcycle"} 
                            value={this.props.dashboardInfo.deliveredOrders+" delivered orders(s)"} />

                            {/* BALANCE  */}
                        <ArtistDashboardSections 
                            text={"Balance To be Paid"} 
                            icon={"money bill alternate"} 
                            value={this.props.dashboardInfo.balance+" balance owed to you"} />

                            {/* BALANCE  */}
                        <ArtistDashboardSections 
                            text={"Total Amount Paid"} 
                            icon={"arrow alternate circle right"} 
                            value={this.props.dashboardInfo.artistTotalPayments+" amount paid to you"} />

                        <h3> {this.state.loginMessage}</h3>
                    </Grid.Column>
                </Grid>

                {/* <Card>
                            <Card.Content>
                                <Image floated='right' size='mini' src='https://react.semantic-ui.com/images/avatar/large/steve.jpg' />
                                <Card.Header>Steve Sanders</Card.Header>
                                <Card.Meta>Friends of Elliot</Card.Meta>
                                <Card.Description>
                                    Steve wants to add you to the group <strong>best friends</strong>
                                </Card.Description>
                            </Card.Content>
                            <Card.Content extra>
                                <div className='ui two buttons'>
                                    <Button basic color='green'>
                                        Approve
                                    </Button>
                                    <Button basic color='red'>
                                        Decline
                                    </Button>
                                </div>
                            </Card.Content>
                        </Card> */}

            </div>
        );
    }
}

export default ArtistDashboardUi;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/artists/ArtistDashboardUi.js